/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Grid({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#Grid_svg__a)" clipRule="evenodd"><path d="M2.5.9A1.6 1.6 0 0 0 .9 2.5v3a1.6 1.6 0 0 0 1.6 1.6h3a1.6 1.6 0 0 0 1.6-1.6v-3A1.6 1.6 0 0 0 5.5.9zm-.4 1.6c0-.22.18-.4.4-.4h3c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-3a.4.4 0 0 1-.4-.4zM2.5 8.9a1.6 1.6 0 0 0-1.6 1.6v3a1.6 1.6 0 0 0 1.6 1.6h3a1.6 1.6 0 0 0 1.6-1.6v-3a1.6 1.6 0 0 0-1.6-1.6zm-.4 1.6c0-.22.18-.4.4-.4h3c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-3a.4.4 0 0 1-.4-.4zM8.9 2.5A1.6 1.6 0 0 1 10.5.9h3a1.6 1.6 0 0 1 1.6 1.6v3a1.6 1.6 0 0 1-1.6 1.6h-3a1.6 1.6 0 0 1-1.6-1.6zm1.6-.4a.4.4 0 0 0-.4.4v3c0 .22.18.4.4.4h3a.4.4 0 0 0 .4-.4v-3a.4.4 0 0 0-.4-.4zM10.5 8.9a1.6 1.6 0 0 0-1.6 1.6v3a1.6 1.6 0 0 0 1.6 1.6h3a1.6 1.6 0 0 0 1.6-1.6v-3a1.6 1.6 0 0 0-1.6-1.6zm-.4 1.6c0-.22.18-.4.4-.4h3c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-3a.4.4 0 0 1-.4-.4z" /></g><defs><clipPath id="Grid_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;